import type { Cart } from '../types';

const getCartTotalItems = (cart: Cart): number => {

  if (cart?.items) {
    return cart.items.reduce((prev, curr) => prev + curr?.qty, 0);
  }
  return 0;
};

const isCartWithOutdatedEvents = (cart: Cart): boolean => {
  if (cart?.items) {
    return cart.items.filter((item) => item.available === false).length > 0;
  }
  return false;
};

export const cartGetters = {
  getCartTotalItems,
  isCartWithOutdatedEvents
};
